<template>
  <div class="payPop">
    <a-modal :footer="null" width="606px" centered :visible="isVisible" @cancel="cancel">
      <template slot="title">
        <span class="title">支付订单</span>
        <span class="sub-title">如有疑问请拨打客服电话 18020506879</span>
      </template>
      <a-row v-if="!isOnPay" class="row" type="flex">
        <label>基础服务：</label>
        <div class="item active">
          <div class="price">
            <span class="num">{{priceObj.base_price}}</span>
            元
          </div>
          <div class="dec">{{isCut?'证件照裁剪':'证件照换底色'}}</div>
        </div>
      </a-row>
      <a-row v-if="!isOnPay && !isCut" class="row" type="flex">
        <label>增值服务：</label>
        <div :class="`item ${isAllBg?'active':''}`" @click="changeIsAllBg">
          <div class="price">
            <span class="num">{{priceObj.pics_fee}}</span>
            元
          </div>
          <div class="dec">保存全部底色</div>
        </div>
        <div v-if="isFormal" :class="`item ${isClothes?'active':''}`" @click="changeIsClothes">
          <div class="price">
            <span class="num">{{priceObj.formal_wear_fee}}</span>
            元
          </div>
          <div class="dec">个性换正装</div>
        </div>
      </a-row>
      <a-row v-if="!isOnPay" class="row" type="flex">
        <a-button type="primary" style="margin-top:20px;" size="large" @click="goPay" block>去支付</a-button>
      </a-row>
      <a-row v-if="isOnPay" class="row" type="flex">
        <label>支付方式：</label>
        <div
          v-for="(item,idx) in payWayArr"
          :key="idx"
          :class="`payWayItem ${payWayNum == idx?'active':''}`"
          @click="changePayWay(idx)"
        >
          <img v-if="idx == 0" class="payWay-img" src="../assets/alipayWay.png" alt />
          <img v-if="idx == 1" class="payWay-img" src="../assets/wxpay.png" alt />
        </div>
      </a-row>
      <a-row v-if="isOnPay" class="row payQr-wrp" type="flex">
        <div class="img-wrap">
          <img :src="payUrl" class="payQrCode" alt="支付二维码" />
        </div>
        <div class="pay-dec">
          <div class="pay-text">
            应付金额：
            <span class="price-num">￥{{sumPrice}}</span>
          </div>
          <!-- <div class="pay-tips">扫描二维码支付，查看订单时请用当前的支付方式登录</div> -->
          <div class="pay-tips">支付后请勿关闭网页，证件照会自动保存</div>
        </div>
      </a-row>
    </a-modal>
  </div>
</template>

<script>
import { getPrice, aliPay, wxPay, queryOrder } from "@/utils/api";
export default {
  name: "payPop",
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    isFormal: {
      type: Boolean,
      default: true
    },
    isCut: {
      type: Boolean,
      default: false
    },
    isMakePic: {
      type: Boolean,
      default: false
    },
    isChangeBg: {
      type: Boolean,
      default: false
    },
    cancel: Function,
    setImageKeyToSessionStorage: Function,
    colorsIdx: {
      type: Number,
      default: 0
    },
    colors: {
      type: Array,
      default: function() {}
    },
    picType: {
      type: String,
      default: "base_map"
    },
    isClothesBol: {
      type: Boolean,
      default: false
    },
    specId: Number
  },
  data() {
    return {
      isAllBg: true, //默认多背景
      isClothes: null,
      isOnPay: false,
      payWayNum: 0,
      payWayArr: ["", ""],
      aliPayUrl: "",
      wxPayUrl: "",
      payUrl: "https://iph.href.lu/140x140?text=%20*",
      interval: null,
      timeOut: null,
      isGoOnHeart: null,
      order_no: {},
      priceObj: {
        base_price: null,
        single_fee: null,
        tailoring_fee: null,
        base_map_fee: null,
        pics_fee: null,
        formal_wear_fee: null
      }
    };
  },
  computed: {
    sumPrice: function() {
      return (
        this.priceObj.base_price +
        (this.isAllBg && !this.isCut && this.priceObj.pics_fee) +
        (this.isClothes && this.priceObj.formal_wear_fee)
      ).toFixed(2);
    }
  },
  created() {
    getPrice().then(res => {
      Object.keys(res).forEach(key => {
        this.priceObj[key] = +(res[key] / 100).toFixed(2);
      });
      // isCut ? priceObj.tailoring_fee:priceObj.base_map_fee

      this.isCut && (this.priceObj.base_price = this.priceObj.tailoring_fee);
      this.isChangeBg &&
        (this.priceObj.base_price = this.priceObj.base_map_fee);
      this.isMakePic && (this.priceObj.base_price = this.priceObj.single_fee);
    });
    this.isClothes = this.isClothesBol;
  },
  beforeDestroy() {
    this.isGoOnHeart = false;
    window.clearInterval(this.timeOut);
    this.timeOut = null;
  },
  methods: {
    goPay() {
      let data = {
        image_key: sessionStorage.getItem("image_key"),
        pic_type: this.picType
      };
      if (this.isCut) {
        data.spec_id = this.specId;
      }
      if (this.isChangeBg)
        data.colour = this.isAllBg
          ? this.colors
          : [this.colors[this.colorsIdx]];
      if (this.isMakePic) {
        data.colour = this.isAllBg
          ? this.colors
          : [this.colors[this.colorsIdx]];
        data.spec_id = this.specId;
        data.is_formal_wear = this.isClothes;
      }
      aliPay(data).then(res => {
        this.aliPayUrl = res.qrcode;
        this.payUrl = this.aliPayUrl;
        this.order_no.alino = res.order_no;
        this.starQuery();
      });
      wxPay(data).then(res => {
        this.wxPayUrl = res.qrcode;
        this.order_no.wxno = res.order_no;
      });
      this.isOnPay = true;
    },
    heartQuery(orderno) {
      if (this.isGoOnHeart) {
        queryOrder(orderno).then(res => {
          if (res.state === "completed") {
            this.isOnPay = false;
            this.$message.success(`支付成功`);
            window.clearInterval(this.timeOut);
            this.$router.push(`/orderPreview?orderno=${orderno}`);
          } else {
            setTimeout(_ => {
              this.heartQuery(orderno);
            }, 2000);
          }
        });
      }
    },
    starQuery() {
      let orderno =
        this.payWayNum === 0 ? this.order_no.alino : this.order_no.wxno;
      setTimeout(_ => {
        this.isGoOnHeart = true;
        this.heartQuery(orderno);
      }, 2000);
      this.timeOut = setTimeout(_ => {
        this.$error({
          title: "支付超时",
          content: "请重新发起支付"
        });
        this.isGoOnHeart = false;
        this.cancel();
      }, 300000);
    },
    changePayWay(idx) {
      this.isGoOnHeart = false;
      this.payUrl = idx === 0 ? this.aliPayUrl : this.wxPayUrl;
      this.payWayNum = idx;
      this.starQuery();
    },
    changeIsAllBg() {
      this.isAllBg = !this.isAllBg;
    },
    changeIsClothes() {
      if (!this.isClothesBol && !this.isClothes) {
        this.$message.error("请换正装！");
        return;
      }
      this.isClothes = !this.isClothes;
      this.setImageKeyToSessionStorage(this.isClothes);
    }
  }
};
</script>
<style scoped>
.title {
  color: #666666;
  font-size: 14px;
}
.sub-title {
  color: #999999;
  font-size: 12px;
  margin-left: 8px;
}
.row {
  margin-bottom: 16px;
}
.payQr-wrp {
  margin-top: 30px;
}
.item {
  margin-left: 17px;
  width: 140px;
  height: 85px;
  border-radius: 4px;
  border: 1px solid #e5e5ea;
  text-align: center;
  padding: 8px 10px;
  cursor: pointer;
}
.item.active {
  border: 1px solid #438bf9;
}
.price {
  border-bottom: 1px dashed #dcdfe6;
}
.num {
  color: #438bf9;
  font-size: 24px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  margin-right: 3px;
}
.dec {
  color: #5a5a5a;
  margin-top: 8px;
}
.payQrCode {
  margin-left: calc(5em + 17px);
  width: 140px;
  height: auto;
}
.pay-dec {
  margin-left: 25px;
}
.pay-text {
  font-size: 16px;
  font-weight: 500;
}
.price-num {
  font-size: 28px;
  color: #ff2500;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
}
.pay-tips {
  /* font-size: 12px; */
  font-size: 15px;
  color: #ff2500;
  /* color: #666666; */
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  line-height: 17px;
  margin-top: 5px;
}
.payWayItem {
  margin-left: 17px;
  width: 140px;
  /* height: 85px; */
  border-radius: 4px;
  border: 1px solid #e5e5ea;
  text-align: center;
  cursor: pointer;
  box-sizing: content-box;
  display: inline-block;
}
.payWayItem.active,
.payWayItem:hover {
  border-color: #438bf9;
}
.payWay-img {
  width: 140px;
}
</style>